import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import moment from "moment";

@Component({
  selector: "icn-calendar-datepicker",
  templateUrl: "./calendar-datepicker.component.html",
  styleUrls: ["./calendar-datepicker.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarDatepickerComponent implements OnChanges, OnInit {
  active: boolean;

  @Input() dateTime: moment.Moment = moment();


  @Input()
  overrideStyle: { [key: string]: string } = null;

  @Output() apply = new EventEmitter<moment.Moment>();
  @Output() cancel = new EventEmitter<CalendarDatepickerComponent>();
  @Output() afterInit = new EventEmitter<CalendarDatepickerComponent>();

  @Input() noTimePicker = false;
  @ViewChild("hourInputElem", { static: true }) hourInput: ElementRef;
  @ViewChild("minutesInputElem", { static: true }) minutesInput: ElementRef;

  minutesInputFocused = false;
  hourInputFocused = false;

  hours = "00";
  minutes = "00";
  date: Date;

  constructor(
    private elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}
  ngOnInit(): void {
    this.afterInit.emit(this);
  }

  onApply(event) {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (!this.active) {
      return;
    }
    const hours = parseInt(this.hours, 10);
    const minutes = parseInt(this.minutes, 10);

    if (isNaN(hours) || isNaN(minutes)) {
      return;
    }
    const newDate = moment().tz("UTC");
    newDate.set({
      date: this.date.getDate(),
      month: this.date.getMonth(),
      year: this.date.getFullYear(),
      hours: hours,
      minutes: minutes,
      seconds: 0,
      millisecond: 0,
    });
    this.active = false;
    this.apply.emit(newDate);
  }

  onHourInputFocus() {
    this.hourInput.nativeElement.focus();
  }

  onMinutesInputFocus() {
    this.minutesInput.nativeElement.focus();
  }

  onHourInputBlur(input) {
    if (!input.valid) {
      this.hours = "00";
    } else {
      this.hours = this.padWithZeros(this.hours);
    }
    this.hourInputFocused = false;
    this.changeDetectorRef.markForCheck();
  }

  onMinutesInputBlur(input) {
    if (!input.valid) {
      this.minutes = "00";
    } else {
      this.minutes = this.padWithZeros(this.minutes);
    }
    this.minutesInputFocused = false;
    this.changeDetectorRef.markForCheck();
  }

  padWithZeros(val: string) {
    return val.length === 1 ? "0" + val : val;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["dateTime"] &&
      changes["dateTime"].currentValue &&
      changes["dateTime"].currentValue.isSame &&
      !changes["dateTime"].currentValue.isSame(
        changes["dateTime"].previousValue,
      )
    ) {
      this.setTime(this.dateTime);
    }
  }

  setTime(newDateTime: moment.Moment) {
    this.dateTime = newDateTime;
    this.hours = this.padWithZeros(newDateTime.hour().toString());
    this.minutes = this.padWithZeros(newDateTime.minute().toString());
    this.date = this.dateTime.toDate();
  }

  closeCalendar() {
    this.active = false;
    this.cancel.emit(this);
  }

  show(currentDate: moment.Moment = null): void {
    this.active = true;

    if (!!currentDate) {
      this.setTime(currentDate);
    }
    this.changeDetectorRef.markForCheck();
  }

  hide(): void {
    this.active = false;
    this.changeDetectorRef.markForCheck();
  }
}
